/* istanbul ignore file */
// eslint-disable-next-line import/no-unassigned-import
import './data-dog-rum';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Cookies from 'js-cookie';

import { App } from './App';
import { AppProviders } from 'mf_core/provider';

// eslint-disable-next-line import/no-unassigned-import
import type {} from '@im/im-theme/themeAugmentation';

import { ScrollToTop } from './ScrollToTop';

Cookies.set('IMOnline_CEP', 'true');

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <AppProviders basename="/cep/app" envVars={process.env}>
    <ScrollToTop />
    <App />
  </AppProviders>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
